import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useLenis } from 'lenis/react'
import { forEach } from 'lodash'
import { useShallow } from 'zustand/shallow'

import { useTransitionStore } from '@/contexts/transition/use-transition-store'

export const useGridMotion = () => {
  const motionRef = useRef<HTMLDivElement>(null)
  const [landing, reveal] = useTransitionStore(useShallow((state) => [state.landing, state.reveal]))
  const lenis = useLenis()

  /**
   * reveal setup
   */
  useGSAP(
    () => {
      if (!lenis || !(landing || reveal)) return

      const scrollTrigger = ScrollTrigger.batch('[data-motion-card]', {
        start: 'top bottom',
        end: 'bottom top',
        once: true,
        onEnter: (batch) =>
          gsap.fromTo(
            batch,
            { y: 30, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.6,
              ease: 'power2.out',
              stagger: {
                amount: 0.2
              }
            }
          )
      })

      return () => {
        forEach(scrollTrigger, (st) => st.kill())
      }
    },
    { scope: motionRef, dependencies: [lenis, landing, reveal] }
  )

  return { motionRef }
}
